const doc = [({"en":({"js":({"admin":({"photo_types":({"select":({"choose_photo_type":"Choose photo type"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;